import React from "react";
import { Card, List } from "antd";

const HolidayListWidget = () => {
  const holidays = [
    { name: "Republic Day", date: "26 Jan" },
    { name: "Mahashivratri", date: "8 Mar" },
  ];

  return (
    <Card title="Upcoming Holidays" bordered={false}>
      <List
        dataSource={holidays}
        renderItem={(item) => (
          <List.Item>
            <b>{item.name}</b> — {item.date}
          </List.Item>
        )}
      />
    </Card>
  );
};

export default HolidayListWidget;
